import angular from 'angular';
import sharedModule from '../../shared.module';

class TokenProvider {
    constructor(
        $q,
        $sessionStorage,
        authenticationService,
        tokenApiService,
        sessionStorageConstants,
        sessionTypeConstants
    ) {
        this.$q = $q;
        this.$sessionStorage = $sessionStorage;
        this.authenticationService = authenticationService;
        this.tokenApiService = tokenApiService;
        this.sessionStorageConstants = sessionStorageConstants;
        this.sessionTypeConstants = sessionTypeConstants;

        this.promiseCache = {};
    }

    getToken(moduleName, sessionStorageName) {
        var deferred = this.$q.defer();

        this.authenticationService.getToken().then(cloudToken => {
            if (!cloudToken) {
                deferred.reject();
                return;
            }

            this.tokenApiService.getToken(cloudToken, moduleName).then(data => {
                angular.merge(data, {
                    expiresOn:
                        new Date().getTime() +
                        Math.max((data.expires - 300) * 1000, 0)
                });
                this.$sessionStorage[sessionStorageName] = data;
                deferred.resolve(data);
            }, deferred.reject);
        }, deferred.reject);

        return deferred.promise;
    }

    getBearerTokenHeader(moduleName) {
        if (!moduleName) {
            return this.$q.reject('noModuleName');
        }

        var sessionStorageName = `token_${moduleName}`;

        if (
            this.$sessionStorage[sessionStorageName] &&
            this.$sessionStorage[sessionStorageName].expiresOn &&
            new Date().getTime() <
                this.$sessionStorage[sessionStorageName].expiresOn
        ) {
            return this.$q.resolve({
                Authorization: `${
                    this.$sessionStorage[sessionStorageName].tokenType
                } ${this.$sessionStorage[sessionStorageName].token}`
            });
        }

        const sessionType = this.sessionStorageConstants.sessionType;
        if (
            this.$sessionStorage[sessionType] ===
            this.sessionTypeConstants.guest
        ) {
            return this.$q.resolve({});
        }

        var promiseId = `getBearerTokenHeader_${moduleName}`;
        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }

        var deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;

        this.getToken(moduleName, sessionStorageName)
            .then(data => {
                deferred.resolve({
                    Authorization: `${data.tokenType} ${data.token}`
                });
            }, deferred.reject)
            .finally(() => delete this.promiseCache[promiseId]);

        return deferred.promise;
    }
}

export default sharedModule.service('tokenProvider', TokenProvider);



// WEBPACK FOOTER //
// ./modules/shared/services/token/tokenProvider.service.js